export var instanceOfAny = function (object, constructors) { return constructors.some(function (c) { return object instanceof c; }); };
